import React, { useState } from "react";
import KuikaButton from "../../ui-kit/kuika-button/kuika-button";
import { changedLineIndices } from "./entity-code-diff-helpers";
import "./entity-diff.scss";

interface EntityDiffCodeProps {
  value: string;
  language?: string;
  maxHeight?: number;
  compareValue?: string;
  /** Colors changed lines: "added" → green, "removed" → red. Defaults to a neutral amber. */
  tone?: "added" | "removed";
}

export function EntityDiffCode({
  value,
  language,
  maxHeight = 80,
  compareValue,
  tone
}: EntityDiffCodeProps): React.ReactElement {
  const [expanded, setExpanded] = useState(false);
  const MAX_LEN = 400;
  const needsTruncation = value.length > MAX_LEN;
  const displayValue = !expanded && needsTruncation ? value.substring(0, MAX_LEN) + "..." : value;

  const lines: string[] = displayValue.split("\n");
  const hasCompare: boolean = compareValue != null;
  const compareLines: string[] = compareValue?.split("\n") ?? [];
  const changed: Set<number> = hasCompare ? changedLineIndices(lines, compareLines) : new Set<number>();

  return (
    <div>
      {/* maxHeight is caller-overridable (default 80), so it stays a computed inline value rather than a class. */}
      <pre
        className="kuika-entity-diff__code"
        style={{ maxHeight: expanded ? 300 : maxHeight }}
        data-language={language}
      >
        {hasCompare
          ? lines.map((line, i) => {
              const isChanged: boolean = changed.has(i);
              return (
                <div
                  key={i}
                  className="kuika-entity-diff__code-line"
                  data-changed={isChanged || undefined}
                  data-tone={isChanged ? (tone ?? "neutral") : undefined}
                >
                  {line}
                </div>
              );
            })
          : displayValue}
      </pre>
      {needsTruncation && (
        <div className="kuika-entity-diff__show-more">
          <KuikaButton type="text" size="sm" onClick={() => setExpanded(!expanded)}>
            {expanded ? "Show less" : "Show more"}
          </KuikaButton>
        </div>
      )}
    </div>
  );
}
